const ReportsEventsList = {
  editReportName: 'rprt_editReportName',
  editQuestionBtn: 'rprt_editQuestionBtn',
  editQuestionSave: 'rprt_editQuestionSave',
  editGameSettingsBtn: 'rprt_editGameSettingsBtn',
  editGameSettingsSave: 'rprt_editGameSettingsSave',
  endGameBtn: 'rprt_endGameBtn',
  editDeadlineBtn: 'rprt_editDeadlineBtn',
  gameLinkShare: 'rprt_gameLinkShare',
  flashcardsBtn: 'rprt_flashcardsBtn',
  deleteBtn: 'rprt_deleteBtn',
  printReportBtn: 'rprt_printReportBtn',
  playerSort: 'rprt_playerSort',
  evaluateBtn: 'rprt_evaluateBtn',
  evaluationModified: 'rprt_evaluationModified',
  emailParent: 'rprt_emailParent',
  playerReportOpened: 'rprt_playerReportOpened',
  questionReportOpened: 'rprt_questionReportOpened',
  questionSort: 'rprt_questionSort',
  subgroupsSort: 'rprt_subgroupsSort',
  tagReportOpened: 'rprt_tagReportOpened',
  reopenAssignmentBtn: 'rprt_reopenAssignmentBtn',
  assignmentReopened: 'rprt_assignmentReopened',
  shareReportBtn: 'rprt_shareReportBtn',
  reportShared: 'rprt_reportShared',
  reportSharedLinkCopied: 'rprt_reportSharedLinkCopied',
  assignHomeworkBtn: 'rprt_assignHomeworkBtn',
  generateLMSGameLink: 'rprt_generateLMSGameLink',
  reattemptGCLBtn: 'rprt_reattemptGCLBtn',
  repetitionToggle: 'rprt_repetitionToggle',
  isOldReport: 'rprt_isOldReport',
  refresh: 'rprt_refresh',
  infoIconHover: 'rprt_info_hover',
  tabSwitch: 'rprt_tab_switch',
};

export default ReportsEventsList;
